import React, { forwardRef } from 'react';

import { useClassnames } from '@lumapps/classnames';
import { SkeletonRectangle } from '@lumapps/lumx/react';

interface WidgetSkeletonRectangleProps {
    htmlId?: string;
    style?: any;
    useDefaultHeight?: boolean;
    widgetId?: string;
}

const CLASSNAME = 'widget-skeleton';
export const WidgetSkeletonRectangle = forwardRef<HTMLDivElement, WidgetSkeletonRectangleProps>(
    ({ htmlId, style, useDefaultHeight = true, widgetId }, ref) => {
        const { block, element } = useClassnames(CLASSNAME);
        const className = block({
            'default-height': useDefaultHeight,
        });

        return (
            <div ref={ref} id={htmlId} className={className} style={style} data-widget-id={widgetId}>
                <SkeletonRectangle className={element('content')} />
            </div>
        );
    },
);

WidgetSkeletonRectangle.displayName = 'WidgetSkeletonRectangle';
